import { combineReducers } from 'redux'

import pageAnswersDiscussion from './pageAnswersDiscussion'
import questionAnswersDiscussion from './questionAnswersDiscussion'

export default combineReducers({
  pageAnswersDiscussion,
  questionAnswersDiscussion,
})
